import _ from 'lodash';

import * as BECaller from '../../util/apiCaller';
import { notifyForDashboard } from '../../util/iframeNotifier';
import { isLoading as dataIsLoading } from '../../modules/App/AppActions';

import { logout } from '../../modules/Auth/AuthActions';
import { setError, setSuccessMessage } from '../../modules/App/ErrorsActions';
import { trackFileUpload } from '../../util/mixpanel';

export const NO_DASHBOARDS = 'NO_DASHBOARDS';
export const ERROR = 'DASHBOARDS_ERROR';
export const LOADING = 'DASHBOARDS_LOADING';
export const LOADING_DATA = 'DASHBOARDS_LOADING_DATA';
export const SUCCESS = 'DASHBOARDS_SUCCESS';
export const SUCCESS_TEAMS = 'DASHBOARDS_SUCCESS_TEAMS';
export const SUCCESS_BOARDS = 'DASHBOARDS_SUCCESS_BOARDS';
export const SUCCESS_LISTS = 'DASHBOARDS_SUCCESS_LISTS';
export const SUCCESS_FIELDS = 'DASHBOARDS_SUCCESS_FIELDS';
export const SUCCESS_AREAS = 'DASHBOARDS_SUCCESS_AREAS';
export const SUCCESS_CREATE = 'DASHBOARDS_SUCCESS_CREATE';
export const SUCCESS_AKB = 'DASHBOARDS_SUCCESS_AKB';
export const ISSUE = 'DASHBOARDS_ISSUE';
export const SELECT = 'DASHBOARDS_SELECT';
export const MODAL_SHOWN = 'DASHBOARDS_MODAL_SHOWN';

function loadingData(type) {
  return {
    type: LOADING_DATA,
    loadingType: type
  };
}

export function handleError(error, opt) {
  return setError(error, opt);
}

export function handleIssue(issue) {
  return {
    type: ISSUE,
    issue
  }
}

export function isLoading(bool) {
  return {
    type: LOADING,
    isLoading: bool
  };
}

export function success(data) {
  return {
    type: SUCCESS,
    data: data
  };
}

export function successTeams(data) {
  return {
    type: SUCCESS_TEAMS,
    teams: data
  };
}

export function successBoards(boards, boardsInfo) {
  return {
    type: SUCCESS_BOARDS,
    boards,
    boardsInfo
  };
}

export function successLists(data) {
  return {
    type: SUCCESS_LISTS,
    lists: data.lists,
    mapping: data.mapping
  };
}

export function successFields(data) {
  return {
    type: SUCCESS_FIELDS,
    fields: data
  };
}

export function successCreate() {
  return {
    type: SUCCESS_CREATE
  };
}

export function selectDashboard(dashboardId, viewId) {
  return {
    type: SELECT,
    selected: dashboardId,
    viewId
  };
}

export function noDashboards() {
  return {
    type: NO_DASHBOARDS
  };
}

export function updateModel(model) {
  return {
    type: MODAL_SHOWN,
    model: model
  };
}

export function listAll(isWallmode) {
  return (dispatch, getState) => {
    const appState = getState().app;
    const queryParams = [];
    if (appState.plugin && appState.plugin.projectId) {
      queryParams.push(`pid=${encodeURIComponent(appState.plugin.projectId)}`);
    }
    if (appState.plugin && appState.plugin.dashboardId) {
      queryParams.push(`dashboardId=${encodeURIComponent(appState.plugin.dashboardId)}`);
    }
    const query = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';    
    return BECaller.api(`dashboards/list${query}`, 'get')
      .then(data => {
        if (appState.plugin && appState.plugin.boardId && appState.plugin.app !== 'jira') {
          data = data.filter(d => d.boardId === appState.plugin.boardId);
        }
        if (appState.plugin && appState.plugin.dashboardId && appState.plugin.app !== 'jira') {
          data = data.filter(d => d._id === appState.plugin.dashboardId);
        }
        if (data.length) {
          let selected = getState().dashboards.selected;
          if (selected && selected._id) {
            let selectedDashboard = _.find(data, b => b._id == selected._id);
            selectedDashboard && dispatch(selectDashboard({ ...selectedDashboard }));
          }          
          dispatch(success(_.sortBy(data, 'name')));
          return data;
        } else {
          dispatch(noDashboards());
        }
      })
      .catch(err => {
        if (err.status == 401) {
          return dispatch(logout());
        }
        dispatch(handleError(err));
      });
  };
}

export function getTeams() {
  return dispatch => {
    dispatch(loadingData('boards'));
    BECaller.api(`integrations/teams`, 'get').then(
      data => {
        const teams = _(data)
          .sortBy('name')
          .sortBy('projectName')
          .value();

        dispatch(successTeams(teams));
      },
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function getBoards(name, pid, tid, projectsSkip = 0, boardsSkip = 0) {
  return (dispatch, getState) => {
    if (!name) {
      dispatch(loadingData('boards'));
    }
    const queryParams = [];

    if (name) {
      queryParams.push(`q=${encodeURIComponent(name)}`);
    }
    const appState = getState().app;
    if (appState.plugin && appState.plugin.projectId) {
      pid = appState.plugin.projectId;
    }
    if (pid) {
      queryParams.push(`pid=${encodeURIComponent(pid)}`);
      if (tid) {
        queryParams.push(`tid=${encodeURIComponent(tid)}`);
      }
    }
    if (boardsSkip) {
      queryParams.push(`boardsSkip=${boardsSkip}`);
    }
    if (projectsSkip) {
      queryParams.push(`projectsSkip=${projectsSkip}`);
    }
    const query = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    
    BECaller.api(`integrations/boards${query}`, 'get').then(
      data => {
        const boards = _(data.boards)
          .map(b => {
            if (!b.organization) {
              b.organization = {
                displayName: ''
              };
            }
            return b;
          })
          .sortBy('name')
          .sortBy('organization.displayName')
          // .toPairs()
          .value();

        dispatch(
          successBoards(boards, {
            boardsTotal: data.boardsTotal,
            boardsLoaded: data.boardsLoaded,
            boardsSkip,
            projectsTotal: data.projectsTotal,
            projectsLoaded: data.projectsLoaded,
            projectsSkip
          })
        );    
      },
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function getLists(boardId, orgId, dashboardId, isAzure = false) {
  return dispatch => {
    dispatch(loadingData('lists'));
    const listsPromise = BECaller.api(
      `integrations/lists?boardId=${boardId}&pid=${orgId}${!!dashboardId ? `&dashboardId=${dashboardId}` : ''}`,
      'get'
    )
      .then(data => {
        dispatch(successLists(data));
      })
      .catch(err => {
        dispatch(handleIssue(err));
        dispatch({
          type: LOADING_DATA,
          loadingType: ''
        });
        if (err && err.data && err.data.board && err.data.board.msg === 'error.board.nopermissions') {
          return Promise.reject('no-permissions');
        }
      });

    const fieldsPromise = BECaller.api(`integrations/customfields?boardId=${boardId}&pid=${orgId}&isAzure=${isAzure}`, 'get')
      .then(data => {
        dispatch(successFields(data));
      })
      .catch(err => {
        dispatch(handleIssue(err));
        dispatch({
          type: LOADING_DATA,
          loadingType: ''
        });
        if (err.data && err.data.board && err.data.board.msg === 'error.board.nopermissions') {
          return Promise.reject('no-permissions');
        }
      });

    return Promise.all([listsPromise, fieldsPromise]);
  };
}

export function getAreas(pid) {
  return dispatch => {
    BECaller.api(`integrations/areas?pid=${pid}`, 'get').then(
      data => {
        return dispatch({
          type: SUCCESS_AREAS,
          areas: data
        });
      },
      err => {
        if (err && err.data && err.data.board && err.data.board.msg) {
          return dispatch(handleIssue(err));
        }
        return dispatch(handleError(err));
      }
    );
  };
}

export function getById(id) {
  return dispatch => {
    return BECaller.api(`dashboards/${id}`, 'get').then(
      data => {
        dispatch(selectDashboard({ ...data, lastUpdated: +new Date() }));
        notifyForDashboard(id);
      },
      err => {
        if (err.status == 401) {
          return dispatch(logout());
        }
        dispatch(handleError(err));
      }
    );
  };
}

export function setWallboardDashboard(id) {
  return dispatch => {
    return BECaller.api(`dashboards/${id}`, 'get')
      .then(data => {
        dispatch(success([data]));
      })
      .catch(err => {
        if (err.status == 401) {
          return dispatch(logout());
        }
        dispatch(handleError(err));
      });
  };
}

export function create(data) {
  return dispatch => {
    dispatch(isLoading(true));
    data.tz = !!window.Intl ? Intl.DateTimeFormat().resolvedOptions().timeZone : null;
    BECaller.api(`dashboards/create`, 'post', data).then(
      res => {
        dispatch(getById(res.dashboardId));
        dispatch(saveSelected(res.dashboardId));
        dispatch(successCreate());
      },
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function update(dashboardId, data) {
  return dispatch => {
    dispatch(isLoading(true));
    BECaller.api(`dashboards/${dashboardId}?isUpdate=true`, 'put', data).then(
      data => {
        dispatch(selectDashboard({ ...data, lastUpdated: +new Date() }));

        dispatch(successCreate());
      },
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function updateDashboardName(dashboardId, name) {
  return (dispatch, getState) => {
    BECaller.api(`dashboards/${dashboardId}/name`, 'post', { name }).then(
      data => {
        // const { selected, dashboardModel } = getState().dashboards;
        // dispatch(selectDashboard({ ...selected, ...data }));
        // dispatch(updateModel({ ...dashboardModel, ...data }));
        dispatch(listAll());
        dispatch(setSuccessMessage(`Dashboard name successfully changed to ${name}`));
      },
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function refetch(dashboardId, from) {
  return (dispatch, getState) => {
    dispatch(dataIsLoading(true));
    BECaller.api(`dashboards/${dashboardId}/refetch`, 'put', { from }).then(
      data => {
        const { selected } = getState().dashboards;
        dispatch(selectDashboard({ ...selected, ...data, lastUpdated: +new Date() }));

        dispatch(successCreate());
      },
      err => {
        dispatch(dataIsLoading(false));
        dispatch(handleError(err));
      }
    );
  };
}

export function remove(dashboardId) {
  return dispatch => {
    BECaller.api(`dashboards/${dashboardId}`, 'delete').then(
      () => {
        dispatch(listAll());
      },
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function saveSelected(id) {
  return dispatch => {
    BECaller.api(`dashboards/selected`, 'put', {
      id
    }).then(
      () => {},
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function uploadFile(id, file, isCsv, type, dashboardId) {
  return dispatch => {
    const formData = new FormData();
    formData.append('data', file);
    formData.append('id', id);
    formData.append('type', type);
    formData.append('tz', !!window.Intl ? Intl.DateTimeFormat().resolvedOptions().timeZone : null);

    const url = dashboardId ?
      (isCsv ? `upload_csv/${dashboardId}` : `upload/${dashboardId}`) :
      (isCsv ? 'upload_csv' : 'upload');

    return BECaller.apiWithFormData(url, formData).then(
      res => {
        trackFileUpload(isCsv? 'csv' : 'json');

        return Promise.resolve(res);
      },
      err => {
        dispatch(handleError(err));
        return Promise.reject(err);
      }
    );
  };
}

export function downloadReport(dashboardId) {
  return (dispatch, getState) => {
    const { dates } = getState().filters;

    BECaller.api(`dashboards/${dashboardId}/log`, 'post', {
      from: dates.startDate.toISOString(),
      to: dates.endDate.toISOString(),
      offset: new Date().getTimezoneOffset()
    }).then(
      res => {
        return BECaller.downloadFile(res.url, res.filename);
      },
      err => {
        dispatch(handleError(err));
      }
    );
  };
}

export function applyView(dashboardId, viewId) {
  return (dispatch, getState) => {
    return BECaller.api(`/dashboards/${dashboardId}/views/${viewId}`, 'put').then(
      savedConfig => {
        updateDashboards(dashboardId, savedConfig, getState, dispatch);
        return Promise.resolve();
      },
      err => {
        this.props.setError(err);
        return Promise.reject(err);
      }
    );
  };
}

function updateDashboards(dashboardId, config, getState, dispatch) {
  const { selected, list } = getState().dashboards;
  const applyingConfig = {
    chartConfig: config.chartConfig || {},
    globalConfig: {
      ...config.globalConfig,
      from: selected.globalConfig.from,
      to: selected.globalConfig.to,
      fixedStartDate: selected.globalConfig.fixedStartDate,
      customDate: selected.globalConfig.customDate,
      dateDiff: selected.globalConfig.dateDiff
    }
  };

  const dashboards = _.map(list, d => {
    if (d._id === dashboardId) {
      d = {
        ...d,
        ...config
      };
    }
    return d;
  });

  dispatch(success(dashboards));
  dispatch(
    selectDashboard({
      ...selected,
      ...config,
      lastUpdated: +new Date()
    })
  );
}

export function loadAkb() {
  return dispatch => {
    BECaller.api('akb/installed', 'get').then(
      data => {
        return dispatch({
          type: SUCCESS_AKB,
          data
        });
      },
      err => {
        return dispatch(handleError(err));
      }
    );
  };
}

export function getConfigByJql(boardId, akbBoardId) {
  return dispatch => {
    dispatch(loadingData('lists'));
    const listsPromise = BECaller.api(`integrations/jql-lists?boardId=${boardId}&akbBoardId=${akbBoardId}`, 'get')
      .then(data => {
        dispatch(successLists(data));
      })
      .catch(err => {
        dispatch(handleIssue(err));
        dispatch({
          type: LOADING_DATA,
          loadingType: ''
        });
        if (err.data && err.data.board && err.data.board.msg === 'error.board.nopermissions') {
          return Promise.reject('no-permissions');
        }
      });

    const fieldsPromise = BECaller.api(`integrations/jql-fields?boardId=${boardId}&akbBoardId=${akbBoardId}`, 'get')
      .then(data => {
        dispatch(successFields(data));
      })
      .catch(err => {
        dispatch(handleIssue(err));
        dispatch({
          type: LOADING_DATA,
          loadingType: ''
        });
        if (err.data && err.data.board && err.data.board.msg === 'error.board.nopermissions') {
          return Promise.reject('no-permissions');
        }
      });

    return Promise.all([listsPromise, fieldsPromise]);
  };
}
